// extracted by mini-css-extract-plugin
export default {"itemContainer":"style_itemContainer__xVzgz","content":"style_content__XV0fu","title":"style_title__mgO4i"};